import React, {useCallback} from 'react';
import {TextField} from '@mui/material';

interface NotesFieldProps {
  value: string;
  onValueChange: (name: string, value: string) => void;
}

/**
 * Remarks / Notes multiline text field.
 * Preserves original casing — no uppercase or sanitization applied.
 */
const NotesField: React.FC<NotesFieldProps> = ({value, onValueChange}) => {
  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onValueChange('notes', e.target.value);
  }, [onValueChange]);

  return (
    <TextField
      id="notes"
      name="notes"
      label="Remarks or Notes"
      value={value}
      onChange={handleChange}
      placeholder="Enter any notes about the check in."
      variant="standard"
      fullWidth
      multiline
      minRows={3}
      inputProps={{'aria-label': 'Remarks or Notes'}}
    />
  );
};

export default NotesField;

